import { getLessonCourtIds } from '@court-sync/shared';

/** Comma-separated court names from explicit court id list. */
export function courtNamesLabelFromCourtIds(
  courtIds: string[],
  courtNamesById?: Record<string, string>
): string | undefined {
  if (!courtNamesById || Object.keys(courtNamesById).length === 0) return undefined;
  const names = courtIds
    .map((id) => courtNamesById[id])
    .filter((n): n is string => !!n && n.trim().length > 0);
  if (names.length === 0) return undefined;
  return names.join(', ');
}

/** Comma-separated court names using an id→name map (e.g. from schedule API). */
export function courtNamesLabelFromLesson(
  lesson: { courtIds?: string[]; courtId?: string },
  courtNamesById?: Record<string, string>
): string | undefined {
  if (!courtNamesById || Object.keys(courtNamesById).length === 0) return undefined;
  return courtNamesLabelFromCourtIds(getLessonCourtIds(lesson), courtNamesById);
}
